import { Link, useNavigate } from "react-router-dom";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline, mdiChevronRight, mdiLockOutline, mdiOfficeBuildingOutline } from "@mdi/js";
import { useQuery } from "react-query";

import { ModuleEntity, ModulePermissionEntity, SkeletonCount } from "../../config/defines";
import { modulePermissionCheck } from "../../config/utils";
import { useAuth } from "../../context/AuthContext";
import { CompanyGetCompaniesResponseEntity } from "../../entities/CompanyEntity";
import CompanyService from "../../services/CompanyService";

import CompanyCard from "../../components/CompanyCard";
import Layout from "../../components/Layout";

export default function Empresas() {
	const companyService = new CompanyService();

	const navigate = useNavigate();
	const { user } = useAuth();

	const { data, isLoading, isRefetching, isError } = useQuery<CompanyGetCompaniesResponseEntity>(["empresas"], () => fetchData());

	async function fetchData() {
		let resp = await companyService.getCompanies();
		return resp.data;
	}

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Link to={"/acessos"} className="d-flex text-decoration-none">
					<Icon path={mdiLockOutline} size={1} className="me-1" /> Acessos
				</Link>
				<Icon path={mdiChevronRight} size={1} className="ms-1 me-1" />
				<Icon path={mdiOfficeBuildingOutline} size={1} className="me-1" /> Empresas
				{isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="d-flex gap-2 float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					{modulePermissionCheck(user!, ModuleEntity.acessos, ModulePermissionEntity.editar) && (
						<Button
							variant="primary"
							className="rounded-3 shadow-sm"
							onClick={() => {
								navigate("/empresaFormulario");
							}}
						>
							Cadastrar
						</Button>
					)}
				</div>
			</h5>

			<Row className="mb-4">
				{isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<CompanyCard skeleton />
							</Col>
						);
					})}
				{!isLoading && isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!isLoading && data && data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{!isLoading &&
					data &&
					data.length >= 1 &&
					data.map((item, index) => {
						return (
							<Col md={12} key={item.id}>
								<CompanyCard data={item} />
							</Col>
						);
					})}
			</Row>
		</Layout>
	);
}
